import { axiosDS } from '@pp/axios'
import {
	OrderCreateParams,
	Region,
	ResponseCatalog,
	OrderModel,
	DadataIpAddress,
	Product,
	ParamsUrl,
	InnDataModel,
	LeadCreate,
	PartnerInfo,
	AgreementModel,
} from 'Pages/landings/common/types'
import { dadataApiKey, OutLinks, urls } from 'Pages/landings/common/constants'

interface RequestParams extends Record<string, any> {
	page: number
	per_page: number
}

export const landingApi = {
	getRegions: async () => {
		const res = await axiosDS().get<ResponseCatalog<Region>>(urls.orders.regions)
		return res.data
	},

	createOrder: async (params: OrderCreateParams & ParamsUrl, id?: string) => {
		const res = await axiosDS().post<OrderModel>(`${urls.orders.externalForm}/${id}/order/`, {
			data: params,
		})
		return res.data
	},

	postLeadCreate: async (params: LeadCreate) => {
		const res = await axiosDS().post<LeadCreate>(urls.landings.leadCreate, { data: params })
		if (res.status === 201) return res.data
	},

	getPartnerInfo: async (token: string) => {
		const res = await axiosDS().get<PartnerInfo>(`${urls.orders.externalForm}/${token}`)
		return res.data
	},

	getAgreementModel: async () => {
		const res = await axiosDS().get<AgreementModel>(urls.landings.agreementModel)
		return res.data
	},

	getIp: async () => {
		const res = await axiosDS({ isExternal: true }).get<string>(OutLinks.getIp)
		return res.data
	},

	getDadataAddressByIp: async (ip: string) => {
		const urlData = OutLinks.daData.replace(':ip', ip)
		const responseConfig = {
			headers: {
				Authorization: `Token ${dadataApiKey}`,
			},
		}
		const res = await axiosDS({ isExternal: true }).get<DadataIpAddress>(urlData, responseConfig)
		return res.data
	},

	getExternalFormProducts: async (token: string) => {
		const res = await axiosDS().get<Product[]>(
			`${urls.orders.externalForm}/${token}/order/products`
		)
		return res.data
	},

	getCatalogRegionsMqApi: async (requestParams?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<Region>>(urls.orders.regions, {
			params: requestParams,
		})
		return res.data
	},

	sendPostbackExternalForm: async (clickId: string, trackId: string, partnerInn: string) => {
		const postBackUrl = OutLinks.postback[partnerInn]
			.replace(':click_id', clickId)
			.replace(':track_id', trackId)
		return axiosDS().get(postBackUrl)
	},

	getInnRbidosRequestApi: async (data: InnDataModel) => {
		const res = await axiosDS().post<{ inn: string }>(`${urls.cabinet.inn}`, data)
		return res.data
	},

	getOrderBuild: async (token: string, data: ParamsUrl & { inn: string }) => {
		const res = await axiosDS().post<OrderModel>(
			`${urls.orders.externalForm}/${token}/order/build`,
			{
				data,
			}
		)
		return res.data
	},
}
